//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittitle/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveUnitTitle: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittitle/edit/save", vo, successCallback, failureCallback);
    },
};

export default EditService;
